const TOGGLE_LOGIN_IS_OPEN = "ui/shared/authentication/TOGGLE_LOGIN_IS_OPEN";

export default {
  TOGGLE_LOGIN_IS_OPEN,
};
